import { memo } from 'react'
import { styled } from '@mui/material'
import { EditOutlinedIcon } from '$common/icons'
import { showCreateNewChatModal } from '$comp/modals/new-chat'
import { useShouldShowFabButton } from '$logic/client-device'
import { FabButton } from '$logic/client-device/fab-buttons'
import { useIsChatListGoingDown } from '$comp/_app/components/leftPanel/components/chat-list/react-hooks'
import { clsx } from 'clsx'
import { ChatListFab } from '$comp/_app/components/leftPanel/components/chat-list/components/shared/fab'

const Fab = styled(ChatListFab)`
  position: absolute;
  left: 12px;
`

export const CreateRoomFab = memo(() => {
  const [
    shouldShowCreateRoomFab,
    shouldShowToolboxFab,
    shouldShowStaticWappsFab,
  ] = useShouldShowFabButton([
    FabButton.CREATE_ROOM,
    FabButton.TOOLBOX,
    FabButton.STATIC_WAPPS,
  ])

  const isChatListGoingDown = useIsChatListGoingDown()

  if (!shouldShowCreateRoomFab) return null

  return (
    <Fab
      className={clsx({ hide: isChatListGoingDown })}
      sx={{
        bottom:
          shouldShowStaticWappsFab || shouldShowToolboxFab ? '68px' : '12px',
      }}
      color="secondary"
      onClick={showCreateNewChatModal}
    >
      <EditOutlinedIcon />
    </Fab>
  )
})
